<app-base-template (modal)="openModal(content)"  (searchmodal) = "searchModal()"  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Platform User Authorization</div>

  </div>
  <div class="modal-body" style="height: 460px; overflow: auto;">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="userSelected" (change)="onUserChange($event.target.selectedIndex)">
        <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
      </select>
    </div>
    <table class="table table-hover font-13 dayChecked">

      <tbody>
        <tr *ngFor="let module of modules;let i=index;" >
          <td><mat-checkbox   [(ngModel)]="module.checked" (change)="showOptions($event)"
                              (change)="checkAll($event.checked,i)"  ></mat-checkbox></td>
          <td>{{module.name}}</td>
          <td><mat-checkbox   [(ngModel)]="module.addChecked">Add</mat-checkbox></td>
          <td><mat-checkbox   [(ngModel)]="module.deleteChecked"> Delete</mat-checkbox></td>
          <td><mat-checkbox   [(ngModel)]="module.viewChecked">View</mat-checkbox></td>
          <td><mat-checkbox   [(ngModel)]="module.editChecked">Edit</mat-checkbox></td>
        </tr>
      </tbody>
    </table>



  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Module Name"
                 [(ngModel)]="moduleSelected">
      </div>
    


  </div>
  <div class="modal-footer pad-8">

          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>

  </div>

  </ng-template>

<notifier-container></notifier-container>